import React from 'react';
import ReactDOM from 'react-dom/client';

// A Inter vinha do Google Fonts, por <link> no public/index.html. Empacotada, ela sai junto com o
// bundle e o app funciona sem rede no primeiro launch — antes, abrir o app offline (ou num 3G ruim)
// renderizava a tela inteira na fonte de fallback do sistema e depois a trocava.
//
// Subset `latin`, e não o arquivo cheio: o site é pt-BR, e os acentos que ele precisa (ã, ç, õ, é)
// estão todos aí. Os quatro pesos são exatamente os que o <link> pedia — 400, 500, 600 e 700 —,
// cerca de 24 KB cada. Peso novo no tailwind.config pede o import correspondente aqui, senão o
// navegador sintetiza o peso e o texto engorda de um jeito que não é o desenho da fonte.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';

import 'styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
